import React from 'react'

import DatasetRoutes from '../routes/dataset'

let DatasetGateway = ({dataset, ...rest}) => {
  if (dataset) return (<DatasetRoutes dataset={dataset} {...rest}/>)
  else return "Loading ..."
}

export default DatasetGateway


// WEBPACK FOOTER //
// ./src/components/DatasetGateway.js